import React from 'react'

export default function AlertIcon(props) {
    const {  color, style } = props;

    return(
        <svg style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} d="M9 0C4.023 0 0 4.0329 0 9C0 13.9689 4.023 18 9 18C13.968 18 18 13.9689 18 9C18 4.0329 13.968 0 9 0ZM9 11.6379C9.432 11.6379 9.783 11.9889 9.783 12.4209C9.783 12.8529 9.432 13.2129 8.991 13.2129C8.559 13.2129 8.208 12.8529 8.208 12.4209C8.208 11.9889 8.559 11.6379 9 11.6379ZM9 4.797C9.432 4.797 9.792 5.1579 9.792 5.589V9.567C9.792 9.9999 9.432 10.35 9 10.35C8.568 10.35 8.217 9.9999 8.217 9.567V5.589C8.217 5.1579 8.568 4.797 9 4.797Z"/>
        </svg>
    )
}